import { generateClient } from "@/utils/helper/aws-generateClient-singleton";
import { PaginatedResponse } from "./createCustomPaginatedQueryOptions";

const client = generateClient();

export async function fetchCustomPaginatedGraphQL<T>(
  query: string,
  variables: Record<string, any>
): Promise<PaginatedResponse<T>> {
  const response: any = await client.graphql({
    query,
    variables,
  });

  const dataKey = Object.keys(response.data)[0];

  if (response.data[dataKey]?.items && response.data[dataKey]?.items.length === 0) {
    return {
      items: [],
      nextToken: null,
    };
  }
  return {
    items: response.data[dataKey]?.items || [],
    nextToken: response.data[dataKey]?.nextToken ?? null,
  };
}
